import classNames from 'classnames';

import { useThemeClassName } from '../../contexts/ThemeContext';
import GameItem from '../items/Game';

import styles from '../../../styles/lists/games.module.scss';

interface GamesListProps {
    className?: string | null;
    items: Game[];
    participations?: Participation[] | null;
    canParticipate?: boolean;
}

function GamesList({
    className = null,
    items,
    participations = null,
    canParticipate = true,
}: GamesListProps) {
    const themeClassName = useThemeClassName(styles);
    return (
        <div className={classNames([styles.container, themeClassName, className])}>
            {items.map((game, index) => {
                const {
                    canParticipate: gameCanParticipate = true,
                    canParticipateAt,
                    theme = null,
                    requiresPincode = false,
                } = game || {};
                const participation =
                    participations !== null
                        ? participations.find(({ gameId }) => gameId === game.id) || null
                        : null;
                return (
                    <GameItem
                        className={styles.item}
                        key={`game-${game.id}`}
                        index={index}
                        game={game}
                        theme={theme}
                        participation={participation}
                        games={items}
                        participations={participations}
                        canParticipate={
                            ((gameCanParticipate || requiresPincode) && canParticipate) ||
                            participation !== null
                        }
                        gameCanParticipate={gameCanParticipate}
                        canParticipateAt={canParticipateAt}
                    />
                );
            })}
        </div>
    );
}

export default GamesList;
